@for (bodyData of itemBodyDetails; track bodyData) {
  <div class="item-summary" [ngClass]="totalItemsLength() == 'even' ? 'evenchild': 'oddchild'">
    @for (headData of itemHeaderDetails; track headData; let i = $index) {
      <div class="item-detail {{headData.jsonkey}} {{headData.class? headData.class:''}}">
        @if (headData.title) {
          <div class="item-values item-{{i}}">
            @if (icons.length >= 1) {
              <span class="{{icons[i]}} detail-icons"></span>
            }
            @if (!headData.hasOwnProperty('customField')) {
              <span class="title" [ngClass]="headData.visibiltyclass ? headData.visibiltyclass:''">{{headData.title}}</span>
            }
            <!--<span class="detail" *ngIf="headData.jsonkey == 'PostDate'">{{bodyData[headData.jsonkey] | date: 'dd/MM/yyyy'}}</span>-->
            @if (headData.jsonkey == 'QuantityonHandForAllLocs') {
              <span class="detail">{{bodyData[headData.jsonkey]}} {{hasBaseUnit(headData.jsonkey) ? baseUnit :''}}</span>
            }
            @if (headData.jsonkey == 'IngMinParForAllLocs') {
              <span class="detail">{{bodyData[headData.jsonkey]}} {{hasBaseUnit(headData.jsonkey) ? baseUnit :''}}</span>
            }
            @if (headData.jsonkey == 'IngMaxParForAllLocs') {
              <span class="detail"  [ngClass]="headData.visibiltyclass ? headData.visibiltyclass:''">{{bodyData[headData.jsonkey]}} {{hasBaseUnit(headData.jsonkey) ? baseUnit :''}}</span>
            }
            @if (bodyData[headData.jsonkey] && headData.jsonkey == 'Status') {
              <span class="detail item-{{headData.jsonkey}} " [ngClass]="bodyData.StatusText | trimLower">{{bodyData[headData.jsonkey]}}</span>
            }
            @if (bodyData[headData.jsonkey] && bodyData[headData.jsonkey].toString() == '' ) {
              <span class="detail empty-field item-{{headData.jsonkey}}">-</span>
            }
            @if (headData.viewMore && bodyData[headData.jsonkey] && bodyData[headData.jsonkey].toString() != '' ) {
              <div #sampleDiv viewMore [configOptions]="config"  class="detail item-{{headData.jsonkey}}" >
                {{bodyData[headData.jsonkey]}}
              </div>
            }
            @if (!headData.viewMore && headData.jsonkey != 'QuantityonHandForAllLocs'
              && headData.jsonkey != 'IngMinParForAllLocs'
              && headData.jsonkey != 'IngMaxParForAllLocs'
              && headData.jsonkey != 'Status'
              &&  bodyData[headData.jsonkey]
              && bodyData[headData.jsonkey].toString() != ''
              && !headData.hasOwnProperty('customField')) {
              <span class="detail item-{{headData.jsonkey}}" >
                {{bodyData[headData.jsonkey]}} {{hasBaseUnit(headData.jsonkey) ? baseUnit:''}}
              </span>
            }
            @if (headData.hasOwnProperty('subScript')) {
              <span class="detail subScript item-{{headData.subScriptJsonKey}}">{{bodyData[headData.subScriptJsonKey]}}</span>
            }
            @if (headData.hasOwnProperty('customField')) {
              <div class='customField'>
                <mat-form-field appearance="outline" class='basic-input-field'>
                  <mat-label>{{'common.remarks' | translate}}</mat-label>
                  <input matInput id="remarks" [(ngModel)]='bodyData[headData.jsonkey]' (change)='remarksChanged(bodyData[headData.jsonkey],bodyData)'>
                </mat-form-field>
              </div>
            }
          </div>
        }
      </div>
    }
  </div>
}
